import { useEffect } from 'react'

type PageMetadata = {
  title: string
  description: string
  canonicalPath?: string
}

export function usePageMetadata({ title, description, canonicalPath = '/' }: PageMetadata) {
  useEffect(() => {
    document.title = title
    let descriptionTag = document.querySelector<HTMLMetaElement>('meta[name="description"]')

    if (!descriptionTag) {
      descriptionTag = document.createElement('meta')
      descriptionTag.name = 'description'
      document.head.append(descriptionTag)
    }

    descriptionTag.content = description
    const canonicalUrl = new URL(canonicalPath, 'https://arksolutionsza.com').toString()
    const canonicalTag = document.querySelector<HTMLLinkElement>('link[rel="canonical"]')
    if (canonicalTag) canonicalTag.href = canonicalUrl

    const socialMetadata = [
      ['meta[property="og:title"]', title],
      ['meta[property="og:description"]', description],
      ['meta[property="og:url"]', canonicalUrl],
      ['meta[name="twitter:title"]', title],
      ['meta[name="twitter:description"]', description],
    ] as const

    for (const [selector, content] of socialMetadata) {
      const tag = document.querySelector<HTMLMetaElement>(selector)
      if (tag) tag.content = content
    }
  }, [canonicalPath, description, title])
}
